export const settingData = {
  formId: 2109153892167815,
  instanceId: 5390,
  title: "营销数字化研讨会",
  meetingType: 0,
  attentionWeChat: null,
  type: 1,
  schemaId: 66669509,
  attachWXAccount: 3352,
  defPcLinkId: 10388,
  defMobileLinkId: 10388,
  attendWay: 1,
  createTime: 1631696121,
  needLogin: 0,
  isPermanent: 1,
  tenantId: 54,
  isReSubmit: 0,
  startTime: 0,
  identity: 1,
  endTime: 0,
  updateTime: 1631696211,
  completeAction: "报名成功",
  moduleType: 2,
  registerFormId: null,
  trackId: "",
  completeActionType: 0,
  luckyDrawId: 0,
  meetingInstanceId: 0,
  extraConfig: null,
  regFormId: 0,
  signupStatus: "allow",
  status: 1,
  items: [
    {
      id: 21587,
      dateLimitType: "",
      fieldDisplayName: "姓名",
      displayName: "姓名",
      displayType: "1",
      extraConfig: null,
      fieldLevel: 1,
      fieldName: "name",
      fieldType: "TEXT",
      fileLimitType: 0,
      isFormed: 1,
      isLogin: 0,
      isSendSms: 0,
      isSystemed: 1,
      listDictId: 0,
      listLimitType: "",
      listOptionType: "",
      listOptions: [],
      listOptionDesc: null,
      maxOptionId: 0,
      required: 1,
      textLength: 0,
      textLimitType: "UNCHECK",
      textRegularExpression: "",
      regularExpression: null,
      dictInfo: null,
      isSensitive: 0,
      moduleId: 3,
      tenantId: 54,
      moduleId2: 7,
      selectOptionLimit: 0,
      privacyPolicyType: null,
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
    },
    {
      id: 21592,
      dateLimitType: "",
      fieldDisplayName: "公司",
      displayName: "公司",
      displayType: "1",
      extraConfig: null,
      fieldLevel: 1,
      fieldName: "enterprise",
      fieldType: "TEXT",
      fileLimitType: 0,
      isFormed: 1,
      isLogin: 0,
      isSendSms: 0,
      isSystemed: 1,
      listDictId: 0,
      listLimitType: "",
      listOptionType: "",
      listOptions: [],
      listOptionDesc: null,
      maxOptionId: 0,
      required: 1,
      textLength: 0,
      textLimitType: "UNCHECK",
      textRegularExpression: "",
      regularExpression: null,
      dictInfo: null,
      isSensitive: 0,
      moduleId: 3,
      tenantId: 54,
      moduleId2: 7,
      selectOptionLimit: 0,
      privacyPolicyType: null,
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
    },
    {
      id: 21588,
      dateLimitType: "",
      fieldDisplayName: "手机",
      displayName: "手机",
      displayType: "1",
      extraConfig: null,
      fieldLevel: 1,
      fieldName: "mobile",
      fieldType: "TEXT",
      fileLimitType: 0,
      isFormed: 1,
      isLogin: 1,
      isSendSms: 0,
      isSystemed: 1,
      listDictId: 0,
      listLimitType: "",
      listOptionType: "",
      listOptions: [],
      listOptionDesc: null,
      maxOptionId: 0,
      required: 1,
      textLength: 11,
      textLimitType: "SYSTEM",
      textRegularExpression: "^(?!(0|86))\\d+$",
      regularExpression: "^(?!(0|86))\\d+$",
      dictInfo: null,
      isSensitive: 1,
      moduleId: 3,
      tenantId: 54,
      moduleId2: 7,
      selectOptionLimit: 0,
      privacyPolicyType: null,
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
    },
    {
      id: 21589,
      dateLimitType: "",
      fieldDisplayName: "邮箱",
      displayName: "邮箱",
      displayType: "1",
      extraConfig: null,
      fieldLevel: 1,
      fieldName: "email",
      fieldType: "TEXT",
      fileLimitType: 0,
      isFormed: 1,
      isLogin: 1,
      isSendSms: 0,
      isSystemed: 1,
      listDictId: 0,
      listLimitType: "",
      listOptionType: "",
      listOptions: [],
      listOptionDesc: null,
      maxOptionId: 0,
      required: 1,
      textLength: 0,
      textLimitType: "SYSTEM",
      textRegularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      regularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      dictInfo: null,
      isSensitive: 1,
      moduleId: 3,
      tenantId: 54,
      moduleId2: 7,
      selectOptionLimit: 0,
      privacyPolicyType: null,
      privacyPolicyUrl: null,
      privacyPolicyTitle: null,
      privacyPolicyUrlTitle: null,
      isSelected: null,
    },
    //{
    //  id: 21590,
    //  dateLimitType: "",
    //  fieldDisplayName: "头像",
    //  displayName: "头像",
    //  displayType: "7",
    //  extraConfig: null,
    //  fieldLevel: 1,
    //  fieldName: "avatar",
    //  fieldType: "FILE",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 1,
    //  listDictId: 0,
    //  listLimitType: "",
    //  listOptionType: "",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "UNCHECK",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: null,
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
    //{
    //  id: 21591,
    //  dateLimitType: "",
    //  fieldDisplayName: "省份",
    //  displayName: "省份",
    //  displayType: "4",
    //  extraConfig: null,
    //  fieldLevel: 1,
    //  fieldName: "province",
    //  fieldType: "LIST",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 1,
    //  listDictId: 66694282,
    //  listLimitType: "RADIO",
    //  listOptionType: "DICT",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "UNCHECK",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: [
    //    {
    //      paramId: "66694283",
    //      name: "北京",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694284: [
    //          {
    //            paramId: "66694285",
    //            name: "北京",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694284",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694286",
    //      name: "天津",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694287: [
    //          {
    //            paramId: "66694288",
    //            name: "天津",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694287",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694289",
    //      name: "河北",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694290: [
    //          {
    //            paramId: "66694291",
    //            name: "石家庄",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694292",
    //            name: "唐山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694293",
    //            name: "秦皇岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694294",
    //            name: "邯郸",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694295",
    //            name: "邢台",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694296",
    //            name: "保定",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694297",
    //            name: "张家口",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694298",
    //            name: "承德",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694299",
    //            name: "沧州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694300",
    //            name: "廊坊",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694301",
    //            name: "衡水",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694290",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694302",
    //      name: "山西",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694303: [
    //          {
    //            paramId: "66694304",
    //            name: "太原",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694305",
    //            name: "大同",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694306",
    //            name: "阳泉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694307",
    //            name: "长治",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694308",
    //            name: "晋城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694309",
    //            name: "朔州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694310",
    //            name: "晋中",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694311",
    //            name: "运城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694312",
    //            name: "忻州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694313",
    //            name: "临汾",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694314",
    //            name: "吕梁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694303",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694315",
    //      name: "内蒙古",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694316: [
    //          {
    //            paramId: "66694317",
    //            name: "呼和浩特",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694318",
    //            name: "包头",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694319",
    //            name: "乌海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694320",
    //            name: "赤峰",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694321",
    //            name: "通辽",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694322",
    //            name: "鄂尔多斯",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694323",
    //            name: "呼伦贝尔",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694324",
    //            name: "巴彦淖尔",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694325",
    //            name: "乌兰察布",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694326",
    //            name: "兴安盟",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694327",
    //            name: "锡林郭勒盟",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694328",
    //            name: "阿拉善盟",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694316",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694329",
    //      name: "辽宁",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694330: [
    //          {
    //            paramId: "66694331",
    //            name: "沈阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694332",
    //            name: "大连",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694333",
    //            name: "鞍山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694334",
    //            name: "抚顺",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694335",
    //            name: "本溪",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694336",
    //            name: "丹东",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694337",
    //            name: "锦州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694338",
    //            name: "营口",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694339",
    //            name: "阜新",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694340",
    //            name: "辽阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694341",
    //            name: "盘锦",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694342",
    //            name: "铁岭",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694343",
    //            name: "朝阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694344",
    //            name: "葫芦岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694330",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694345",
    //      name: "吉林",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694346: [
    //          {
    //            paramId: "66694347",
    //            name: "长春",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694348",
    //            name: "吉林",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694349",
    //            name: "四平",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694350",
    //            name: "辽源",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694351",
    //            name: "通化",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694352",
    //            name: "白山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694353",
    //            name: "松原",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694354",
    //            name: "白城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694355",
    //            name: "延边",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694346",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694356",
    //      name: "黑龙江",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694357: [
    //          {
    //            paramId: "66694358",
    //            name: "哈尔滨",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694359",
    //            name: "齐齐哈尔",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694360",
    //            name: "鸡西",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694361",
    //            name: "鹤岗",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694362",
    //            name: "双鸭山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694363",
    //            name: "大庆",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694364",
    //            name: "伊春",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694365",
    //            name: "佳木斯",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694366",
    //            name: "七台河",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694367",
    //            name: "牡丹江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694368",
    //            name: "黑河",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694369",
    //            name: "绥化",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694370",
    //            name: "大兴安岭",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694357",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694371",
    //      name: "上海",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694372: [
    //          {
    //            paramId: "66694373",
    //            name: "上海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694372",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694374",
    //      name: "江苏",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694375: [
    //          {
    //            paramId: "66694376",
    //            name: "南京",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694377",
    //            name: "无锡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694378",
    //            name: "徐州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694379",
    //            name: "常州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694380",
    //            name: "苏州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694381",
    //            name: "南通",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694382",
    //            name: "连云港",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694383",
    //            name: "淮安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694384",
    //            name: "盐城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694385",
    //            name: "扬州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694386",
    //            name: "镇江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694387",
    //            name: "泰州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694388",
    //            name: "宿迁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694375",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694389",
    //      name: "浙江",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694390: [
    //          {
    //            paramId: "66694391",
    //            name: "杭州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694392",
    //            name: "宁波",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694393",
    //            name: "温州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694394",
    //            name: "嘉兴",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694395",
    //            name: "湖州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694396",
    //            name: "绍兴",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694397",
    //            name: "金华",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694398",
    //            name: "衢州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694399",
    //            name: "舟山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694400",
    //            name: "台州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694401",
    //            name: "丽水",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694390",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694402",
    //      name: "安徽",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694403: [
    //          {
    //            paramId: "66694404",
    //            name: "合肥",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694405",
    //            name: "芜湖",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694406",
    //            name: "蚌埠",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694407",
    //            name: "淮南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694408",
    //            name: "马鞍山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694409",
    //            name: "淮北",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694410",
    //            name: "铜陵",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694411",
    //            name: "安庆",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694412",
    //            name: "黄山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694413",
    //            name: "滁州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694414",
    //            name: "阜阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694415",
    //            name: "宿州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694416",
    //            name: "六安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694417",
    //            name: "亳州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694418",
    //            name: "池州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694419",
    //            name: "宣城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694403",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694420",
    //      name: "福建",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694421: [
    //          {
    //            paramId: "66694422",
    //            name: "福州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694423",
    //            name: "厦门",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694424",
    //            name: "莆田",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694425",
    //            name: "三明",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694426",
    //            name: "泉州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694427",
    //            name: "漳州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694428",
    //            name: "南平",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694429",
    //            name: "龙岩",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694430",
    //            name: "宁德",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694421",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694431",
    //      name: "江西",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694432: [
    //          {
    //            paramId: "66694433",
    //            name: "南昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694434",
    //            name: "景德镇",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694435",
    //            name: "萍乡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694436",
    //            name: "九江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694437",
    //            name: "新余",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694438",
    //            name: "鹰潭",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694439",
    //            name: "赣州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694440",
    //            name: "吉安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694441",
    //            name: "宜春",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694442",
    //            name: "抚州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694443",
    //            name: "上饶",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694432",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694444",
    //      name: "山东",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694445: [
    //          {
    //            paramId: "66694446",
    //            name: "济南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694447",
    //            name: "青岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694448",
    //            name: "淄博",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694449",
    //            name: "枣庄",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694450",
    //            name: "东营",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694451",
    //            name: "烟台",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694452",
    //            name: "潍坊",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694453",
    //            name: "济宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694454",
    //            name: "泰安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694455",
    //            name: "威海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694456",
    //            name: "日照",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694457",
    //            name: "莱芜",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694458",
    //            name: "临沂",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694459",
    //            name: "德州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694460",
    //            name: "聊城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694461",
    //            name: "滨州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694462",
    //            name: "菏泽",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694445",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694463",
    //      name: "河南",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694464: [
    //          {
    //            paramId: "66694465",
    //            name: "郑州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694466",
    //            name: "开封",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694467",
    //            name: "洛阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694468",
    //            name: "平顶山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694469",
    //            name: "安阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694470",
    //            name: "鹤壁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694471",
    //            name: "新乡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694472",
    //            name: "焦作",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694473",
    //            name: "濮阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694474",
    //            name: "许昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694475",
    //            name: "漯河",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694476",
    //            name: "三门峡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694477",
    //            name: "南阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694478",
    //            name: "商丘",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694479",
    //            name: "信阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694480",
    //            name: "周口",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694481",
    //            name: "驻马店",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694464",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694482",
    //      name: "湖北",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694483: [
    //          {
    //            paramId: "66694484",
    //            name: "武汉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694485",
    //            name: "黄石",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694486",
    //            name: "十堰",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694487",
    //            name: "宜昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694488",
    //            name: "襄阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694489",
    //            name: "鄂州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694490",
    //            name: "荆门",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694491",
    //            name: "孝感",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694492",
    //            name: "荆州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694493",
    //            name: "黄冈",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694494",
    //            name: "咸宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694495",
    //            name: "随州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694496",
    //            name: "恩施",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694497",
    //            name: "仙桃",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694498",
    //            name: "潜江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694499",
    //            name: "天门",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694500",
    //            name: "神农架",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694483",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694501",
    //      name: "湖南",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694502: [
    //          {
    //            paramId: "66694503",
    //            name: "长沙",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694504",
    //            name: "株洲",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694505",
    //            name: "湘潭",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694506",
    //            name: "衡阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694507",
    //            name: "邵阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694508",
    //            name: "岳阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694509",
    //            name: "常德",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694510",
    //            name: "张家界",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694511",
    //            name: "益阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694512",
    //            name: "郴州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694513",
    //            name: "永州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694514",
    //            name: "怀化",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694515",
    //            name: "娄底",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694516",
    //            name: "湘西",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694502",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694517",
    //      name: "广东",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694518: [
    //          {
    //            paramId: "66694519",
    //            name: "广州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694520",
    //            name: "韶关",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694521",
    //            name: "深圳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694522",
    //            name: "珠海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694523",
    //            name: "汕头",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694524",
    //            name: "佛山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694525",
    //            name: "江门",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694526",
    //            name: "湛江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694527",
    //            name: "茂名",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694528",
    //            name: "肇庆",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694529",
    //            name: "惠州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694530",
    //            name: "梅州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694531",
    //            name: "汕尾",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694532",
    //            name: "河源",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694533",
    //            name: "阳江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694534",
    //            name: "清远",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694535",
    //            name: "东莞",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694536",
    //            name: "中山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694537",
    //            name: "潮州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694538",
    //            name: "揭阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694539",
    //            name: "云浮",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694518",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694540",
    //      name: "广西",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694541: [
    //          {
    //            paramId: "66694542",
    //            name: "南宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694543",
    //            name: "柳州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694544",
    //            name: "桂林",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694545",
    //            name: "梧州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694546",
    //            name: "北海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694547",
    //            name: "防城港",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694548",
    //            name: "钦州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694549",
    //            name: "贵港",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694550",
    //            name: "玉林",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694551",
    //            name: "百色",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694552",
    //            name: "贺州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694553",
    //            name: "河池",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694554",
    //            name: "来宾",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694555",
    //            name: "崇左",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694541",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694556",
    //      name: "海南",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694557: [
    //          {
    //            paramId: "66694558",
    //            name: "海口",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694559",
    //            name: "三亚",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694560",
    //            name: "五指山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694561",
    //            name: "琼海",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694562",
    //            name: "儋州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694563",
    //            name: "文昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694564",
    //            name: "万宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694565",
    //            name: "东方",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694566",
    //            name: "定安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694567",
    //            name: "屯昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694568",
    //            name: "澄迈",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694569",
    //            name: "临高",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694570",
    //            name: "白沙",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694571",
    //            name: "昌江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694572",
    //            name: "乐东",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694573",
    //            name: "陵水",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694574",
    //            name: "保亭",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694575",
    //            name: "琼中",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694576",
    //            name: "西沙群岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694577",
    //            name: "南沙群岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694578",
    //            name: "中沙群岛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694579",
    //            name: "洋浦",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694557",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694580",
    //      name: "重庆",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694581: [
    //          {
    //            paramId: "66694582",
    //            name: "重庆",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694581",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694583",
    //      name: "四川",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694584: [
    //          {
    //            paramId: "66694585",
    //            name: "成都",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694586",
    //            name: "自贡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694587",
    //            name: "攀枝花",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694588",
    //            name: "泸州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694589",
    //            name: "德阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694590",
    //            name: "绵阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694591",
    //            name: "广元",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694592",
    //            name: "遂宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694593",
    //            name: "内江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694594",
    //            name: "乐山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694595",
    //            name: "南充",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694596",
    //            name: "眉山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694597",
    //            name: "宜宾",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694598",
    //            name: "广安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694599",
    //            name: "达州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694600",
    //            name: "雅安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694601",
    //            name: "巴中",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694602",
    //            name: "资阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694603",
    //            name: "阿坝",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694604",
    //            name: "甘孜",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694605",
    //            name: "凉山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694584",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694606",
    //      name: "贵州",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694607: [
    //          {
    //            paramId: "66694608",
    //            name: "贵阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694609",
    //            name: "六盘水",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694610",
    //            name: "遵义",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694611",
    //            name: "安顺",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694612",
    //            name: "黔西南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694613",
    //            name: "黔东南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694614",
    //            name: "黔南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694607",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694615",
    //      name: "云南",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694616: [
    //          {
    //            paramId: "66694617",
    //            name: "昆明",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694618",
    //            name: "曲靖",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694619",
    //            name: "玉溪",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694620",
    //            name: "保山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694621",
    //            name: "昭通",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694622",
    //            name: "丽江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694623",
    //            name: "普洱",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694624",
    //            name: "临沧",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694625",
    //            name: "楚雄",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694626",
    //            name: "红河",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694627",
    //            name: "文山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694628",
    //            name: "西双版纳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694629",
    //            name: "大理",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694630",
    //            name: "德宏",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694631",
    //            name: "怒江",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694632",
    //            name: "迪庆",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694616",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694633",
    //      name: "西藏",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694634: [
    //          {
    //            paramId: "66694635",
    //            name: "拉萨",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694636",
    //            name: "昌都",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694637",
    //            name: "山南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694638",
    //            name: "日喀则",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694639",
    //            name: "那曲",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694640",
    //            name: "阿里",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694641",
    //            name: "林芝",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694634",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694642",
    //      name: "陕西",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694643: [
    //          {
    //            paramId: "66694644",
    //            name: "西安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694645",
    //            name: "铜川",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694646",
    //            name: "宝鸡",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694647",
    //            name: "咸阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694648",
    //            name: "渭南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694649",
    //            name: "延安",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694650",
    //            name: "汉中",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694651",
    //            name: "榆林",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694652",
    //            name: "安康",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694653",
    //            name: "商洛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694643",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694654",
    //      name: "甘肃",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694655: [
    //          {
    //            paramId: "66694656",
    //            name: "兰州",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694657",
    //            name: "嘉峪关",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694658",
    //            name: "金昌",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694659",
    //            name: "白银",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694660",
    //            name: "天水",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694661",
    //            name: "武威",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694662",
    //            name: "张掖",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694663",
    //            name: "平凉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694664",
    //            name: "酒泉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694665",
    //            name: "庆阳",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694666",
    //            name: "定西",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694667",
    //            name: "陇南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694668",
    //            name: "临夏",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694669",
    //            name: "甘南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694655",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694670",
    //      name: "青海",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694671: [
    //          {
    //            paramId: "66694672",
    //            name: "西宁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694673",
    //            name: "海东",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694674",
    //            name: "海北",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694675",
    //            name: "黄南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694676",
    //            name: "海南",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694677",
    //            name: "果洛",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694678",
    //            name: "玉树",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694679",
    //            name: "海西",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694671",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694680",
    //      name: "宁夏",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694681: [
    //          {
    //            paramId: "66694682",
    //            name: "银川市",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694681",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694683",
    //            name: "石嘴山",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694681",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694684",
    //            name: "吴忠",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694681",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694685",
    //            name: "固原",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694681",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694686",
    //            name: "中卫",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694681",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694687",
    //      name: "新疆",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694688: [
    //          {
    //            paramId: "66694689",
    //            name: "乌鲁木齐",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694690",
    //            name: "克拉玛依",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694691",
    //            name: "吐鲁番",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694692",
    //            name: "哈密",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694693",
    //            name: "昌吉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694694",
    //            name: "博尔塔拉",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694695",
    //            name: "巴音郭楞",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694696",
    //            name: "阿克苏",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694697",
    //            name: "克孜勒",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694698",
    //            name: "喀什",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694699",
    //            name: "和田",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694700",
    //            name: "伊犁",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694701",
    //            name: "塔城",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694702",
    //            name: "阿勒泰",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694703",
    //            name: "石河子",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694704",
    //            name: "阿拉尔",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694705",
    //            name: "图木舒克",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //          {
    //            paramId: "66694706",
    //            name: "五家渠",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694688",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694707",
    //      name: "台湾",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694708: [
    //          {
    //            paramId: "66694709",
    //            name: "台湾",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694708",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694710",
    //      name: "香港",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694711: [
    //          {
    //            paramId: "66694712",
    //            name: "香港",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694711",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66694713",
    //      name: "澳门",
    //      isDefault: "0",
    //      createTime: 1586934747,
    //      dicId: "66694282",
    //      child: {
    //        66694714: [
    //          {
    //            paramId: "66694715",
    //            name: "澳门",
    //            isDefault: "0",
    //            createTime: 1586934747,
    //            dicId: "66694714",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //  ],
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
    //{
    //  id: 21593,
    //  dateLimitType: "",
    //  fieldDisplayName: "部门",
    //  displayName: "部门",
    //  displayType: "3",
    //  extraConfig: null,
    //  fieldLevel: 1,
    //  fieldName: "department",
    //  fieldType: "LIST",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 1,
    //  listDictId: 66694252,
    //  listLimitType: "RADIO",
    //  listOptionType: "DICT",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "UNCHECK",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: [
    //    {
    //      paramId: "66694253",
    //      name: "财务部",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694252",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694254",
    //      name: "人事部",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694252",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694255",
    //      name: "采购部",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694252",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694256",
    //      name: "市场部",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694252",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694257",
    //      name: "销售部",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694252",
    //      child: [],
    //    },
    //  ],
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
    //{
    //  id: 21594,
    //  dateLimitType: "",
    //  fieldDisplayName: "职务",
    //  displayName: "职务",
    //  displayType: "3",
    //  extraConfig: null,
    //  fieldLevel: 1,
    //  fieldName: "position",
    //  fieldType: "LIST",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 1,
    //  listDictId: 66694258,
    //  listLimitType: "RADIO",
    //  listOptionType: "DICT",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "UNCHECK",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: [
    //    {
    //      paramId: "66694259",
    //      name: "董事长",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694258",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694260",
    //      name: "总经理",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694258",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694261",
    //      name: "总经理秘书",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694258",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694262",
    //      name: "经理",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694258",
    //      child: [],
    //    },
    //    {
    //      paramId: "66694263",
    //      name: "销售人员",
    //      isDefault: "0",
    //      createTime: 1481299200,
    //      dicId: "66694258",
    //      child: [],
    //    },
    //  ],
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
    //{
    //  id: 21595,
    //  dateLimitType: "",
    //  fieldDisplayName: "ew",
    //  displayName: "ew",
    //  displayType: "1",
    //  extraConfig: null,
    //  fieldLevel: 2,
    //  fieldName: "m_we",
    //  fieldType: "TEXT",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 0,
    //  listDictId: 0,
    //  listLimitType: "",
    //  listOptionType: "",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "UNCHECK",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: null,
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
    //{
    //  id: 21596,
    //  dateLimitType: "",
    //  fieldDisplayName: "级联行业",
    //  displayName: "级联行业",
    //  displayType: "3",
    //  extraConfig: null,
    //  fieldLevel: 2,
    //  fieldName: "m_jilianhangye",
    //  fieldType: "LIST",
    //  fileLimitType: 0,
    //  isFormed: 1,
    //  isLogin: 0,
    //  isSendSms: 0,
    //  isSystemed: 0,
    //  listDictId: 66711821,
    //  listLimitType: "RADIO",
    //  listOptionType: "DICT",
    //  listOptions: [],
    //  listOptionDesc: null,
    //  maxOptionId: 0,
    //  required: 0,
    //  textLength: 0,
    //  textLimitType: "",
    //  textRegularExpression: "",
    //  regularExpression: null,
    //  dictInfo: [
    //    {
    //      paramId: "66711824",
    //      name: "制造业",
    //      isDefault: "0",
    //      createTime: 1591779412,
    //      dicId: "66711821",
    //      child: {
    //        66711822: [
    //          {
    //            paramId: "66711826",
    //            name: "其他",
    //            isDefault: "0",
    //            createTime: 1591779424,
    //            dicId: "66711822",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //    {
    //      paramId: "66711825",
    //      name: "其他",
    //      isDefault: "0",
    //      createTime: 1591779419,
    //      dicId: "66711821",
    //      child: {
    //        66711823: [
    //          {
    //            paramId: "66711827",
    //            name: "其他",
    //            isDefault: "0",
    //            createTime: 1591779431,
    //            dicId: "66711823",
    //            child: [],
    //          },
    //        ],
    //      },
    //    },
    //  ],
    //  isSensitive: 0,
    //  moduleId: 3,
    //  tenantId: 54,
    //  moduleId2: 7,
    //  selectOptionLimit: 0,
    //  privacyPolicyType: null,
    //  privacyPolicyUrl: null,
    //  privacyPolicyTitle: null,
    //  privacyPolicyUrlTitle: null,
    //  isSelected: null,
    //},
  ],
};

export const settingMeetingData = {
  targetParticipantCount: "",
  jincieryi: "",
  jllb: "",
  isTester: "1",
  creatorId: "03-0002-00100547",
  topicConfigId: "1118571",
  memberFormId: "",
  modifyTime: "1635316530",
  shareTitle: "",
  rq: "",
  ticketConfigId: "1118574",
  proCity: "",
  ddd: "",
  status: "proposed",
  instanceId: "291812",
  sceneDisplayName: "自定义",
  seminarId: "2110270366203443",
  inviteConfigId: "1118573",
  wj: "",
  topicWapConfigId: "1118572",
  createTime: "1635316530",
  duoji: "",
  shareCover: "",
  endTime: "1641117600",
  sj: "",
  memberFormName: "",
  targetRegisterCount: "",
  shareCoverUrl: "",
  isAllForm: "0",
  wdwdw: "",
  tenantId: "1038",
  isDeleted: "0",
  startTime: "1640998800",
  sceneName: "custom",
  weChatId: "287892",
  address: "北京市朝阳区高井文化园路8号",
  creator: "xue",
  hywjtp: "",
  lb: "",
  weChatType: "custom",
  title: "营销一体化年度峰会",
  desc: "",
  isOpenMember: "0",
  uniqueField: null,
  logoMapId: null,
  guests: [
    {
      attendedCount: "0",
      createTime: "1635316531",
      demartment: "技术部",
      duty: "总裁",
      email: "",
      enterprise: "华为",
      gender: "男",
      guestId: "2107140147578283",
      imageMapId: "",
      intro: "",
      isPublic: "是",
      modifyTime: "1635316531",
      name: "龚俊",
      phone: "15000000000",
      tenantId: "1038",
      role: "",
      jbdx: null,
      aa: "null",
      fdshsksak: null,
      seminarId: "2110270366203443",
      seminarGuestTypeId: "40704",
      seminarGuestId: "2110272975313098",
      global: "",
    },
  ],
  agendas: [
    {
      items: [
        {
          agendaId: "1",
          tenantId: "1038",
          name: "开场嘉宾致辞",
          agendaDate: "1640998800",
          startTime: "1640998800",
          endTime: "1641002400",
          createTime: "1635316531",
          address: "北京",
          remark: "开场嘉宾致辞",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "张某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
        {
          agendaId: "2",
          tenantId: "1038",
          name: "让营销更有价值",
          agendaDate: "1641002400",
          startTime: "1641002400",
          endTime: "1641009600",
          createTime: "1635316531",
          address: "北京",
          remark: "让营销更有价值",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "刘某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
        {
          agendaId: "3",
          tenantId: "1038",
          name: "获客解决方案",
          agendaDate: "1641013200",
          startTime: "1641013200",
          endTime: "1641020400",
          createTime: "1635316531",
          address: "北京",
          remark: "让营销更有价值",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "刘某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
      ],
      itemsSubSeminar: [
        {
          subSeminarName:
            "我是分会场1我是分会场1我是分我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会会场1我是分会场1我是分会场1我是分会场1",
          subSeminarAddress: "1111",
          subSeminarStartTime: "1635213240",
          subSeminarEndTime: "1635321240",
          items: [
            {
              agendaId: "19190",
              tenantId: "0",
              name: "分会场-1",
              agendaDate: "1635213240",
              startTime: "1635213240",
              endTime: "1635213300",
              createTime: "1635316531",
              address: "111发生的",
              remark: "发士大夫士大夫",
              status: "completed",
              guests: [],
            },
          ],
        },
      ],
      agendaDate: 1640998800,
    },
    {
      items: [
        {
          agendaId: "1",
          tenantId: "1038",
          name: "企业可持续增长解决方案",
          agendaDate: "1641085200",
          startTime: "1641085200",
          endTime: "1641088800",
          createTime: "1635316531",
          address: "北京",
          remark: "企业可持续增长解决方案",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "张某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
        {
          agendaId: "2",
          tenantId: "1038",
          name: "让营销更有价值",
          agendaDate: "1641002400",
          startTime: "1641002400",
          endTime: "1641009600",
          createTime: "1635316531",
          address: "北京",
          remark: "让营销更有价值",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "刘某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
        {
          agendaId: "3",
          tenantId: "1038",
          name: "获客解决方案",
          agendaDate: "1641013200",
          startTime: "1641013200",
          endTime: "1641020400",
          createTime: "1635316531",
          address: "北京",
          remark: "让营销更有价值",
          status: "notStarted",
          guests: [
            {
              attendedCount: "0",
              createTime: "1635652489",
              demartment: "部门",
              duty: "职务",
              email: "",
              enterprise: "嘉宾所属公司",
              fdshsksak: "",
              gender: "女",
              global: "1",
              guestId: "2110313442870961",
              guestType: "演讲嘉宾",
              guestTypeId: "40704",
              imageMapId: "",
              intro: "嘉宾所属公司",
              isPublic: "是",
              jbdx: "制造业",
              modifyTime: "1635652489",
              name: "刘某某",
              phone: "15511111111",
              role: "",
              seminarGuestId: "2110313593098153",
              seminarGuestTypeId: "40704",
              seminarId: "2110270366203443",
              tenantId: "1038",
            },
          ],
        },
      ],
      itemsSubSeminar: [
        {
          subSeminarName:
            "我是分会场1我是分会场1我是分我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会场1我是分会会场1我是分会场1我是分会场1我是分会场1",
          subSeminarAddress: "1111",
          subSeminarStartTime: "1635213240",
          subSeminarEndTime: "1635321240",
          items: [
            {
              agendaId: "19190",
              tenantId: "0",
              name: "分会场-1",
              agendaDate: "1635213240",
              startTime: "1635213240",
              endTime: "1635213300",
              createTime: "1635316531",
              address: "111发生的",
              remark: "发士大夫士大夫",
              status: "completed",
              guests: [],
            },
          ],
        },
      ],
      agendaDate: 1641085200,
    },
  ],
  registerId: "35251",
  registerFormId: "2110270554078464",
  next1: "customForm.getListByIds",
  next2: "weChat.getDf",
  next3: "weChat.get",
};
